import { Box, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { WidgetProps } from '@rjsf/utils';
import { MODEL_TYPES } from 'api/model';
import ModelProviderCard from './ModelProviderCard';

export default function ModelProviderSelector({ value, onChange }: WidgetProps) {
  return (
    <Box sx={{ p: 0 }}>
      <RadioGroup value={value as string} onChange={(e) => onChange(e.target.value)}>
        <Grid container spacing={2}>
          {MODEL_TYPES.map((provider) => {
            const isSelected = value === provider;

            return (
              <Grid item xs={12} sm={6} md={4} key={provider}>
                <FormControlLabel
                  value={provider}
                  control={<Radio sx={{ display: 'none' }} />}
                  label={<ModelProviderCard provider={provider} selected={isSelected} />}
                  sx={{ margin: 0, width: '100%', '& .MuiFormControlLabel-label': { width: '100%', minWidth: 0 } }}
                />
              </Grid>
            );
          })}
        </Grid>
      </RadioGroup>
    </Box>
  );
}
